// extracted by mini-css-extract-plugin
export var subtitle = "SectionSubtitle-module--subtitle--6c544";